import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { useInvalidateReservations } from '@repo/domain-service';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  PAYMENT_FAILURE_CONTENT,
  PAYMENT_FAILURE_RETURN_BUTTON_TRANSLATION_KEY,
} from '@features/reservation/constants/paymentResult';
import { readPaymentResult } from '@features/reservation/utils/readPaymentResult';

import PageFrame from '@shared/components/page/PageFrame';

import { ROUTE_PATHS } from '@router/paths';

import failureIllustration from '@assets/images/reservation/failure-illustration.webp';

export default function FailurePage() {
  const testId = TestId.root('reservation.failure');
  const navigate = useNavigate();
  const location = useLocation();
  const invalidateReservations = useInvalidateReservations();
  const { product, returnTo } = readPaymentResult(location.state);
  const content = PAYMENT_FAILURE_CONTENT[product];

  useEffect(() => {
    invalidateReservations();
  }, [invalidateReservations]);

  const handleGoFurther = () => {
    if (returnTo) {
      navigate(returnTo.pathname, { state: returnTo.state, replace: true });
      return;
    }
    navigate(ROUTE_PATHS[content.routeName]);
  };

  return (
    <PageFrame
      fullScreen
      testId={testId}
      forwardButton={{
        label: tr(returnTo ? PAYMENT_FAILURE_RETURN_BUTTON_TRANSLATION_KEY : content.buttonTranslationKey),
        onClick: handleGoFurther,
      }}
    >
      <div className="flex h-full w-full flex-col">
        <div className="flex flex-1 items-center justify-center p-4 text-center">
          <div className="inline-flex w-80 flex-col items-center justify-start gap-3">
            <img src={failureIllustration} alt={tr('reservations:failure.image_alt')} />
            <div className="text-heading justify-start text-2xl leading-8 font-semibold">
              {tr('reservations:failure.title')}
            </div>
            <div className="text-body justify-start text-base leading-6 font-normal whitespace-pre-line">
              {tr('reservations:failure.message')}
            </div>
          </div>
        </div>
      </div>
    </PageFrame>
  );
}
